<router-outlet></router-outlet>
<!-- <ngx-spinner></ngx-spinner> -->
<div class="spinner-container"  [style.display]="isShowSpinner ? 'block' : 'none'">
    <div class="spinner-icon">
        <nz-spin nzSimple [nzSize]="'large'"></nz-spin>
    </div>
</div>